(function($) {

	$(document).ready(function() {

	if ($('.jq-toggle').length) {

		$('.jq-toggle-control:checked').each(function() {
			var $toggle = $(this).parent('.jq-toggle');

			$('.jq-toggle-panel', $toggle).show();
		});

		$(document).on('change', '.jq-toggle-control', function() {
			var $toggle = $(this).parent('.jq-toggle');

			if ($(this).hasClass('jq-toggle-one')) {
				var $toggles = $('[name="' + $(this).attr('name') + '"]');

				$toggles.not(this).prop('checked', false);

				$toggles.nextAll('.jq-toggle-panel').slideUp();

				if ($(this).is(':checked')) {
					$('.jq-toggle-panel', $toggle).slideDown();
				}
			} else {
				$('.jq-toggle-panel', $toggle).slideToggle();
			}
		});

	}

});


})(jQuery);
